@file:OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)

package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonClassDiscriminator

@Serializable
@JsonClassDiscriminator("op")
sealed class WsFrame {
    abstract val op: String
}

@Serializable
@SerialName("SUBSCRIBE")
data class WsSubscribe(
    override val op: String = "SUBSCRIBE",
    val asset_ids: List<String>
) : WsFrame()

@Serializable
@SerialName("UNSUBSCRIBE")
data class WsUnsubscribe(
    override val op: String = "UNSUBSCRIBE",
    val asset_ids: List<String>
) : WsFrame()

@Serializable
@SerialName("ASSET_UPDATED")
data class WsAssetUpdated(
    override val op: String = "ASSET_UPDATED",
    val asset_id: String,
    val status: GenerationStatus,
    val stage: Int? = null,
    val model_url: String? = null,
    val error_message: String? = null,
    val metadata: Map<String, String> = emptyMap(),
    val full_asset: AssetResponse? = null
) : WsFrame()

@Serializable
@SerialName("PING")
data class WsPing(
    override val op: String = "PING",
    val t: Long
) : WsFrame()

@Serializable
@SerialName("PONG")
data class WsPong(
    override val op: String = "PONG"
) : WsFrame()

@Serializable
@SerialName("ERROR")
data class WsError(
    override val op: String = "ERROR",
    val code: Int,
    val message: String
) : WsFrame()
